import {Directive, ElementRef, inject, input, OnInit} from '@angular/core';

@Directive({
  selector: '[appStoryblok]',
  standalone: true
})
export class StoryblokDirective implements OnInit {
  private el = inject(ElementRef);


  readonly appStoryblok = input<string>();

  ngOnInit() {
    const appStoryblok = this.appStoryblok();
    if (typeof appStoryblok === 'undefined') {
      return;
    }

    const options = JSON.parse(appStoryblok.replace('<!--#storyblok#', '').replace('-->', ''));

    this.el.nativeElement.setAttribute('data-blok-c', JSON.stringify(options));
    this.el.nativeElement.setAttribute('data-blok-uid', options.id + '-' + options.uid);
  }

}
